import {
  CREATE_DASHBOARD,
  CREATE_DASHBOARD_ERROR,
  CREATE_DASHBOARD_SUCCESS,
  COPY_DASHBOARD,
  COPY_DASHBOARD_ERROR,
  COPY_DASHBOARD_SUCCESS,
  COPY_DASHBOARD_WIDGET,
  COPY_DASHBOARD_WIDGET_ERROR,
  COPY_DASHBOARD_WIDGET_SUCCESS,
  CREATE_DASHBOARD_WIDGET,
  CREATE_DASHBOARD_WIDGET_ERROR,
  CREATE_DASHBOARD_WIDGET_SUCCESS,
  DELETE_DASHBOARD,
  DELETE_DASHBOARD_ERROR,
  DELETE_DASHBOARD_SUCCESS,
  DELETE_DASHBOARD_WIDGET,
  DELETE_DASHBOARD_WIDGET_ERROR,
  DELETE_DASHBOARD_WIDGET_SUCCESS,
  GET_DASHBOARDS,
  GET_DASHBOARDS_ERROR,
  GET_DASHBOARDS_SUCCESS,
  UPDATE_DASHBOARD,
  UPDATE_DASHBOARD_ERROR,
  UPDATE_DASHBOARD_SUCCESS,
  UPDATE_DASHBOARD_WIDGET,
  UPDATE_DASHBOARD_WIDGET_ERROR,
  UPDATE_DASHBOARD_WIDGET_SUCCESS,
  UPDATE_DASHBOARD_WIDGET_PARAMETERS,
  UPDATE_DASHBOARD_WIDGET_PARAMETERS_ERROR,
  UPDATE_DASHBOARD_WIDGET_PARAMETERS_SUCCESS,
  UPDATE_DASHBOARD_PERMISSIONS,
  UPDATE_DASHBOARD_PERMISSIONS_ERROR,
  UPDATE_DASHBOARD_PERMISSIONS_SUCCESS,
  CLEAR_DASHBOARD_PERMISSIONS_ERROR,
} from './constants'

export const createDashboard = ({ name }) => ({
  type: CREATE_DASHBOARD,
  name,
})
export const createDashboardError = ({ error }) => ({
  type: CREATE_DASHBOARD_ERROR,
  error,
})
export const createDashboardSuccess = ({ dashboard }) => ({
  type: CREATE_DASHBOARD_SUCCESS,
  dashboard,
})

export const copyDashboard = ({
  dashboardType,
  copyDashboardShares,
  id,
  name,
}) => ({
  type: COPY_DASHBOARD,
  dashboardType,
  copyDashboardShares,
  id,
  name,
})
export const copyDashboardError = ({ error }) => ({
  type: COPY_DASHBOARD_ERROR,
  error,
})
export const copyDashboardSuccess = ({ dashboard }) => ({
  type: COPY_DASHBOARD_SUCCESS,
  dashboard,
})

export const copyDashboardWidget = ({ dashboardId, widget }) => ({
  type: COPY_DASHBOARD_WIDGET,
  dashboardId,
  widget,
})
export const copyDashboardWidgetError = () => ({
  type: COPY_DASHBOARD_WIDGET_ERROR,
})

export const copyDashboardWidgetSuccess = ({ widget, temporaryWidgetId }) => ({
  type: COPY_DASHBOARD_WIDGET_SUCCESS,
  widget,
  temporaryWidgetId,
})

export const createDashboardWidget = ({ dashboardId, widget }) => ({
  type: CREATE_DASHBOARD_WIDGET,
  dashboardId,
  widget,
})
export const createDashboardWidgetError = () => ({
  type: CREATE_DASHBOARD_WIDGET_ERROR,
})

export const createDashboardWidgetSuccess = ({
  widget,
  temporaryWidgetId,
}) => ({
  type: CREATE_DASHBOARD_WIDGET_SUCCESS,
  widget,
  temporaryWidgetId,
})

export const deleteDashboard = ({
  companyCode,
  customerCode,
  id,
  navigate,
}) => ({
  type: DELETE_DASHBOARD,
  companyCode,
  customerCode,
  id,
  navigate,
})
export const deleteDashboardError = ({ id, error }) => ({
  type: DELETE_DASHBOARD_ERROR,
  id,
  error,
})
export const deleteDashboardSuccess = ({ id }) => ({
  type: DELETE_DASHBOARD_SUCCESS,
  id,
})

export const deleteDashboardWidget = ({ dashboardId, widgetId }) => ({
  type: DELETE_DASHBOARD_WIDGET,
  widgetId,
  dashboardId,
})

export const deleteDashboardWidgetSuccess = () => ({
  type: DELETE_DASHBOARD_WIDGET_SUCCESS,
})

export const deleteDashboardWidgetError = () => ({
  type: DELETE_DASHBOARD_WIDGET_ERROR,
})

export const getDashboards = ({ companyCode }) => ({
  type: GET_DASHBOARDS,
  companyCode,
})
export const getDashboardsError = (error) => ({
  type: GET_DASHBOARDS_ERROR,
  error,
})
export const getDashboardsSuccess = ({ dashboards }) => ({
  type: GET_DASHBOARDS_SUCCESS,
  dashboards,
})

export const updateDashboard = ({ dashboard, updatedDashboard }) => ({
  type: UPDATE_DASHBOARD,
  dashboard,
  updatedDashboard,
})
export const updateDashboardError = ({ error, dashboardId }) => ({
  type: UPDATE_DASHBOARD_ERROR,
  dashboardId,
  error,
})
export const updateDashboardSuccess = ({ dashboard }) => ({
  type: UPDATE_DASHBOARD_SUCCESS,
  dashboard,
})

export const updateDashboardWidget = ({ dashboardId, editWidget, widget }) => ({
  type: UPDATE_DASHBOARD_WIDGET,
  dashboardId,
  editWidget,
  widget,
})
export const updateDashboardWidgetError = ({ error, widgetId }) => ({
  type: UPDATE_DASHBOARD_WIDGET_ERROR,
  error,
  widgetId,
})
export const updateDashboardWidgetSuccess = ({ dashboardId, widget }) => ({
  type: UPDATE_DASHBOARD_WIDGET_SUCCESS,
  dashboardId,
  widget,
})

export const updateDashboardWidgetParameters = ({
  dashboardId,
  widgetId,
  parameters,
}) => ({
  type: UPDATE_DASHBOARD_WIDGET_PARAMETERS,
  dashboardId,
  widgetId,
  parameters,
})

export const updateDashboardWidgetParametersSuccess = () => ({
  type: UPDATE_DASHBOARD_WIDGET_PARAMETERS_SUCCESS,
})

export const updateDashboardWidgetParametersError = () => ({
  type: UPDATE_DASHBOARD_WIDGET_PARAMETERS_ERROR,
})

export const updateDashboardPermissions = ({ dashboardId, users, roles }) => ({
  type: UPDATE_DASHBOARD_PERMISSIONS,
  dashboardId,
  users,
  roles,
})

export const updateDashboardPermissionsSuccess = ({ dashboard }) => ({
  type: UPDATE_DASHBOARD_PERMISSIONS_SUCCESS,
  dashboard,
})

export const updateDashboardPermissionsError = (error) => ({
  type: UPDATE_DASHBOARD_PERMISSIONS_ERROR,
  error,
})

export const clearDashboardPermissionsError = () => ({
  type: CLEAR_DASHBOARD_PERMISSIONS_ERROR,
})
